import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { LoginGuard } from "@app/guard/login.guard";
import { AccessibilityComponent } from "@app/private/accessibility/accessibility.component";
import { AuctionDetailsComponent } from "@app/private/auction-details/auction-details.component";
import { AuctionsComponent } from "@app/private/auctions/auctions.component";
import { ChangePasswordLoggedComponent } from "@app/private/change-password-logged/change-password-logged.component";
import { FaqComponent } from "@app/private/faq/faq.component";
import { LegalNotesComponent } from "@app/private/legal-notes/legal-notes.component";
import { LiveFullComponent } from "@app/private/live-full/live-full.component";
import { MyLeasysComponent } from "@app/private/my-leasys/my-leasys.component";
import { MyLotComponent } from "@app/private/my-lot/my-lot.component";
import { PrivacyComponent } from "@app/private/privacy/privacy.component";
import { PrivateContactComponent } from "@app/private/private-contact/private-contact.component";
import { PrivateCookieComponent } from "@app/private/private-cookie/private-cookie.component";
import { PrivatePartnerComponent } from "@app/private/private-partner/private-partner.component";
import { PrivatePrivacyComponent } from "@app/private/private-privacy/private-privacy.component";
import { PrivateComponent } from "@app/private/private.component";
import { PurchaseSummaryComponent } from "@app/private/purchase-summary/purchase-summary.component";
import { TermsAndConditionsComponent } from "@app/private/terms-and-conditions/terms-and-conditions.component";
import { UserProfileComponent } from "@app/private/user-profile/user-profile.component";
import { ClickarPath } from "@shared/clickar-constants";

const routes: Routes = [
	{
		path: "",
		component: PrivateComponent,
		canActivate: [LoginGuard],
		canActivateChild: [],
		children: [
			{
				path: "",
				component: AuctionsComponent,
				canActivate: [LoginGuard],
				runGuardsAndResolvers: "always"
			},
			{
				path: ClickarPath.AUCTION_MANAGEMENT,
				loadChildren: () => import("./auction-management/auction-management.module").then(m => m.AuctionManagementModule),
				canActivate: [LoginGuard],
				canActivateChild: [LoginGuard]
			},
			{
				path: ClickarPath.VEHICLE_MANAGEMENT,
				loadChildren: () => import("./vehicle-management/vehicle-management.module").then(m => m.VehicleManagementModule),
				canActivate: [LoginGuard],
				canActivateChild: [LoginGuard]
			},
			{
				path: ClickarPath.SHOWCASE_MANAGEMENT,
				loadChildren: () => import("./showcase-management/showcase-management.module").then(m => m.ShowcaseManagementModule),
				canActivate: [LoginGuard],
				canActivateChild: [LoginGuard]
			},
			{
				path: ClickarPath.SUPPORT,
				component: FaqComponent
			},
			{
				path: ClickarPath.PURCHASE_SUMMARY,
				component: PurchaseSummaryComponent
			},
			{
				path: ClickarPath.USER_PROFILE,
				component: UserProfileComponent
			},
			{
				path: ClickarPath.CHANGE_PASSWORD_LOGGED,
				component: ChangePasswordLoggedComponent
			},
			{
				path: ClickarPath.MY_LEASYS,
				component: MyLeasysComponent
			},
			{
				path: ClickarPath.AUCTION_DETAILS,
				component: AuctionDetailsComponent
			},
			{
				path: ClickarPath.PARTNER,
				component: PrivatePartnerComponent
			},
			{
				path: ClickarPath.PRIVACY,
				component: PrivacyComponent
			},
			{
				path: ClickarPath.LIVE_FULL,
				component: LiveFullComponent
			},
			{
				path: ClickarPath.MY_LOT,
				component: MyLotComponent
			},
			{
				path: ClickarPath.PRIVATE_PRIVACY,
				component: PrivatePrivacyComponent
			},
			{
				path: ClickarPath.PRIVATE_COOKIE,
				component: PrivateCookieComponent
			},
			{
				path: ClickarPath.PRIVATE_CONTACT,
				component: PrivateContactComponent
			},
			{
				path: ClickarPath.TERMS_AND_CONDITIONS,
				component: TermsAndConditionsComponent
			},
			{
				path: ClickarPath.LEGAL_NOTES,
				component: LegalNotesComponent
			},
			{
				path: ClickarPath.ACCESSIBILITY,
				component: AccessibilityComponent
			}
		]
	}
];

@NgModule({
	imports: [
		RouterModule.forChild(routes)
	],
	exports: [
		RouterModule
	],
	providers: []
})
export class PrivateRouterModule { }